/* eslint-disable no-param-reassign */
import { components } from "react-select";
import PropTypes from "prop-types";

const MultiValueRemove = ({ className, preserveStyle, children, ...otherProps }) => {
  if (!preserveStyle) {
    // So that the default styles aren't applied, for full customization
    otherProps.getStyles = () => ({});
  }

  return (
    <components.MultiValueRemove {...otherProps} className={className}>
      {children}
    </components.MultiValueRemove>
  );
};

MultiValueRemove.propTypes = {
  className: PropTypes.string,
  preserveStyle: PropTypes.bool,
  children: PropTypes.node,
};

MultiValueRemove.defaultProps = {
  className: "",
  preserveStyle: false,
  children: null,
};

export default MultiValueRemove;
